import { render, staticRenderFns } from "./SendProduct.vue?vue&type=template&id=a63abe94&scoped=true&"
import script from "./SendProduct.vue?vue&type=script&lang=ts&"
export * from "./SendProduct.vue?vue&type=script&lang=ts&"
import style0 from "./SendProduct.vue?vue&type=style&index=0&id=a63abe94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a63abe94",
  null
  
)

export default component.exports